export const POS_DASHBOARD_PATH = "/pos/dashboard"

export function posPath(path = "") {
  const suffix = path.replace(/^\/+/, "")
  return suffix ? `/pos/${suffix}` : POS_DASHBOARD_PATH
}

export function legacyWebsitePath(pathname, search = "", hash = "") {
  const suffix = pathname.replace(/^\/website(?=\/|$)/, "") || "/"
  const destination = suffix === "/home" ? "/" : suffix
  return `${destination}${search}${hash}`
}
